import { getDate30DaysAgo } from 'src/utils/date';
import { TimePeriodOption } from '../constants';

export function createTimePeriodOptionLast30Days(): TimePeriodOption {
  return {
    key: 'last_30_days',
    label: 'Last 30 days',
    param: {
      start_time: getDate30DaysAgo(new Date()).toISOString(),
      end_time: new Date().toISOString(),
    },
  };
}

export function createTimePeriodOptionAllTime(): TimePeriodOption {
  return {
    key: 'all_time',
    label: 'All time',
    param: {
      end_time: new Date().toISOString(),
    },
  };
}
